import { ViewModel,View } from "binder"
import { IDefaultValueManipulator } from "../defaultValueManipulator";
import  { StringView } from "./string-view"
import { stringIsNullOrEmpty } from "src/common/utilities";
import { IMemberContainer } from "../../../dataModelBuilder-viewModel";

export class StringViewModel extends ViewModel implements IDefaultValueManipulator{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new StringView();
    }
    public getTypeId(): string {
        return "VM-978D7936-D831-41BD-9922-515EDDAD39FD"
    }

    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;
    
    setDefaultValue(defaultValue: any): void {
        this.value = defaultValue;
    }
    getDefaultValue():any {
        return this.value;
    }
    verify(owningClass : IMemberContainer): string[] {
        let result = [];
        if(stringIsNullOrEmpty(this.value)){
            result.push('default value is not specified.')
        }
        return result;
    }
}
